
export let loading_icon = `
	<span class="loading_icon material-symbols-outlined">
		progress_activity
	</span>
`;
